import { IButton, WaListMessageButton } from 'common/builder/buttons/buttonInterfaces'
import { ButtonType } from 'common/builder/constants/ButtonType'

export function isListMessageButton(button: IButton): button is WaListMessageButton {
  return button.type === ButtonType.WA_LIST_MESSAGE_BUTTON
}
